export const INFO = 'info';
export const ERROR = 'error';
export const QR_CODE = 'QRCode';
export const METAMASK = 'metamask';
export const PLAY_GAME = 'playGame';
export const LOW_BALANCE = 'lowBalance';
export const NOT_VERIFIED = 'notVerified';
export const METAMASK_NETWORK_CHANGED = 'metamaskNetworkChanged';
export const CHANNEL_NOT_CREATED = 'channelNotCreated';
export const NEED_TO_LOGIN = 'needToLogin';
export const NEED_TO_SIGN = 'needToSign';
export const SECURITY_INFO = 'securityInfo';
export const BROWSER_SUPPORT = 'browserSupport';
export const CANCEL_WITHDRAW = 'cancelWithdraw';
export const NO_INTERNET_CONNECTION = 'noInternetConnection';
export const UNAUTHORIZED = 'unauthorized';
